import { Image } from 'antd'
import { FileUnknownOutlined } from '@ant-design/icons'

import VideoPlayer from '@/components/VideoPlayer'
import ThreeModelViewer from '@/components/ThreeModelViewer'
import WaveSurferPlayer from '@/components/WaveSurferPlayer'
import GalleyImage from '@/components/GalleyImage'

import { getFileName, proxySourcePath } from '@/utils/common'

const ChatElement = ({ item }: any) => {
  const imageItems = item.pic
    ? item.pic.split(',').map((i: string) => ({
        src: i,
      }))
    : []

  return (
    <>
      {item.scene && (
        <div className="max-h-[300px]">
          <ThreeModelViewer source={proxySourcePath(item.scene)} type="ply" />
        </div>
      )}
      {item.video?.match('.mp4|.mov|.avi') ? (
        <div className="rounded-md overflow-hidden w-full h-auto max-w-96 max-h-96">
          <VideoPlayer
            options={{
              // responsive: true,
              // fluid: true,
              autoplay: item.autoplay,
              controls: !item.autoplay,
              aspectRatio: '16:9',
              sources: [
                {
                  src: proxySourcePath(item.video),
                  type: 'video/mp4',
                },
              ],
            }}
          />
        </div>
        // <Video
        //   size={400}
        //   preview={true}
        //   classNames={{
        //     wrapper: 'rounded-md overflow-hidden',
        //   }}
        //   autoplay={false}
        //   src={item.video}
        // />
      ) : (
        item.video && (
          <div className="flex gap-2 items-center">
            <FileUnknownOutlined className="text-2xl" />
            {getFileName(item.video)}
          </div>
        )
      )}
      {item.audio && (
        <div className="max-w-100% w-96">
          <WaveSurferPlayer
            options={{
              needSpectrogram: item.isSingal,
              height: 100,
              waveColor: 'rgba(0, 13, 71, 0.5)',
              progressColor: 'rgba(0, 13, 71, 1)',
              url: proxySourcePath(item.audio),
            }}
          />
          {/* <AudioPlayer src={proxySourcePath(item.audio)} /> */}
        </div>
      )}
      {imageItems.length > 0 && (
        <Image.PreviewGroup>
          <GalleyImage items={imageItems} />
        </Image.PreviewGroup>
      )}
    </>
  )
}

export default ChatElement
